import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import ReactCalendar from 'react-calendar/dist/entry.nostyle';
import ChevronLeft from '../Icons/ChevronLeft';
import ChevronRight from '../Icons/ChevronRight';

const CalendarWrapper = styled.div`
  position: relative;
  margin: 0px !important;
`;

const Calendar = React.forwardRef((props, ref) => (
  <CalendarWrapper ref={ref} data-testid="calendar">
    <ReactCalendar
      minDate={new Date()}
      minDetail="month"
      formatShortWeekday={(locale, date) => moment(date).format('ddd')[0]}
      calendarType="US"
      prevLabel={<ChevronLeft color="#485465" size={12} />}
      prev2Label={null}
      nextLabel={<ChevronRight color="#485465" size={12} />}
      next2Label={null}
      {...props}
    />
  </CalendarWrapper>
));

Calendar.displayName = 'Calendar';

export default Calendar;
